__webpack_require__.p = "/Game-wheel-of-fortune/";